module.exports = __webpack_public_path__ + "fonts/UTM Androgyne.414742d.ttf";